export default __webpack_public_path__ + "static/media/MiniTape_SideA_08_Interview-Andrej-Malogajski.3a9d7946.mp3";